import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { variation } from 'ember-launch-darkly';

export default class RouteWithUserContext extends Route {
  @service api;
  @service userContext;
  @service router;

  queryParams = {
    project_id: {
      refreshModel: true,
    },
    org_id: {
      refreshModel: true,
    },
  };

  async model({ org_id, project_id }) {
    if (!org_id && !project_id) {
      return {};
    }

    const isProjectContext = project_id ? true : false;
    let project;
    let organization;

    if (isProjectContext) {
      ({ project, organization } = await this.handleProjectContext(
        project_id,
        org_id
      ));
    } else {
      organization = await this.fetchOrganization(org_id);
    }

    await this.userContext.setOrganization(organization);

    if (!isProjectContext) {
      project = this.userContext.projects[0];
    }

    await this.userContext.setProject(isProjectContext ? project : null);

    return {
      isProjectContext,
      project,
      organization,
    };
  }

  async handleProjectContext(project_id, org_id) {
    let project;
    let organization;

    if (org_id) {
      // Fetch in parallel
      const [projectResponse, orgResponse] = await Promise.allSettled([
        this.fetchProject(project_id),
        this.fetchOrganization(org_id),
      ]);

      project = projectResponse.value;
      organization = orgResponse.value;

      // If org_id doesn't match the project's parent, fetch the correct org
      if (org_id !== project.parent?.id || !organization) {
        organization = await this.fetchOrganization(project.parent.id);
      }
    } else {
      // Fetch project first, then organization based on project.parent.id
      project = await this.fetchProject(project_id);
      organization = await this.fetchOrganization(project.parent.id);
    }

    return { project, organization };
  }

  async fetchProject(project_id) {
    const { project } =
      await this.api.resourceManager.project.projectServiceGet(project_id);
    return project;
  }

  async fetchOrganization(org_id) {
    const { organization } =
      await this.api.resourceManager.org.organizationServiceGet(org_id);
    return organization;
  }

  async afterModel(model) {
    if (!model || (!model.organization && !model.project)) {
      let { organizations } =
        await this.api.resourceManager.org.organizationServiceList();
      this.router.transitionTo(this.routeName, {
        queryParams: {
          org_id: organizations[0].id,
        },
      });
    }
  }
}
